import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../proyect.conf';
import { PoliticaDuraDivisionPolitica } from '../_models/politica-dura-division-politica';
import { AutenticacionService } from './autenticacion.service';

@Injectable({
  providedIn: 'root'
})
export class PoliticasDurasDivisionesPoliticasService {
  private rutaBase = AppSettings.rutServiciosAUTOGES + '/api/politicasDurasDivisionesPoliticas';

  constructor(
    private httpClient: HttpClient,
    private authService: AutenticacionService
  ) {}

  obtenerPorIdPoliticaDura(idPoliticaDura: string) {
    return this.httpClient
      .get(`${this.rutaBase}/idPoliticaDura/${idPoliticaDura}/enabled`)
      .pipe(map(res => res as PoliticaDuraDivisionPolitica[]));
  }

  crear(registro: PoliticaDuraDivisionPolitica) {
    registro.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutaBase, registro)
      .pipe(map(res => res as PoliticaDuraDivisionPolitica));
  }

  actualizar(registro: PoliticaDuraDivisionPolitica) {
    registro.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutaBase, registro)
      .pipe(map(res => res as PoliticaDuraDivisionPolitica));
  }

  crearBulk(registros: PoliticaDuraDivisionPolitica[]) {
    const usuario = this.authService.obtenerIdUsuarioLogueado();
    registros.forEach(r => r.auditoriaUsuario = usuario);

    return this.httpClient
      .post(`${this.rutaBase}/bulk`, registros)
      .pipe(map(res => res as PoliticaDuraDivisionPolitica[]));
  }
}
